/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */
import { SysqueSystemCategoryOptionsComponent } from '../../sysque-system-category-options/sysque-system-category-options.component';
import { SystemOptions } from '../../models/system-options';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class DuplicateSystemCategoryDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig, componentTitle?: string): any {
    sysquePopupConfig.component = SysqueSystemCategoryOptionsComponent;
    const systemOptions = new SystemOptions();
    systemOptions.buttonLabel = 'Duplicate';
    sysquePopupConfig.data = systemOptions;
    sysquePopupConfig.width = 505;
    sysquePopupConfig.height = 240;
    sysquePopupConfig.componentTitle = componentTitle;
  }
}
